export default __webpack_public_path__ + "static/media/ESSS30ROSE45_1920x1080.93b54e91.jpg";